var ProductComparison = {

	init: function(){
        Vue.config.devtools = true;

		this.bindUIActions();

        let pcData = {
            products: [],
            productOne: null,
            productTwo: null,
            productThree: null
        };

        let pcMethods = {
            updateSource: function (src) {

            },
            getProducts: function() {
                $.getJSON('/ajax/products', function(resp, textStatus) {
                    console.log(resp);
                    pcData.products = resp;
                    pcData.productOne = resp[0];
                    pcData.productTwo = resp[1];
                    pcData.productThree = resp[2];
                });
            },
            updateProduct: function(columnName, productID) {
                pcData[columnName] = pcData.products[productID-1];
                console.log(columnName);
            }
        };

        new Vue({
            el: '#product-comparison',
            data: pcData,
            methods: pcMethods,
            created: function () {
                pcMethods.getProducts();
            },
            mounted: function() {
                // appData.appIsReady = true;
            },
        });

	},

    bindUIActions: function() {

        $(document).on('click','.cobb-v-select',function(e) {
            var select = $(this);
            var selected = select.find('.selected');
            // Close any open selects
            $('.cobb-select').not(this).removeClass('open');
            // If the main/select el is clicked -> toggle open/closed
            if ($(e.target).hasClass('selected')) {
                select.toggleClass('open');
                return false;
            } else {
                var item = $(e.target);
                select.data('value', item.data('id'));
                selected.data('value', item.data('id'));
                selected.text(item.text());
                select.toggleClass('open');
            }
        });

	}//End bindUIActions


}
